import { render, staticRenderFns } from "./PrivilegeList.vue?vue&type=template&id=c89d3546&"
import script from "./PrivilegeList.vue?vue&type=script&lang=js&"
export * from "./PrivilegeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports